<template>
  <AppError v-if="isErrorDuringFirstLoad" :error="error" />
  <App v-else-if="isLoaded" />
  <AppLoading v-else />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import App from './App.vue';
import AppLoading from './AppLoading.vue';
import AppError from './AppError.vue';
import { useRequiredAppDataStore } from './stores/required-app-data.store';

const requiredAppDataStore = useRequiredAppDataStore();
const { isErrorDuringFirstLoad, error, isLoaded } = storeToRefs(useRequiredAppDataStore());

requiredAppDataStore.load();
</script>
<style lang="scss">
:root {
  --topbar-height: 3.5rem;
  --topbar-padding: var(--topbar-height);
}
</style>
